import React from "react";
import { Button, Card, CardContent, Typography } from "@mui/material";
import imagen from "../../img/Simbolo_ICONTEC-2019-Pos (1).png";

const GraciasComponente = () => {
  // Función para redirigir al hacer clic en el botón
  const redirigir = () => {
    window.location.href = "https://www.icontec.org/"; // Cambia la URL a la que desees redirigir
  };

  return (
    <div
      className="container"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Card sx={{ maxWidth: 600, width: "100%", padding: 3 }}>
        <CardContent style={{ textAlign: "center" }}>
          <img
            src={imagen} // Cambia esta URL por la de tu imagen
            alt="Imagen agradecimiento"
            style={{
              width: "80%",
              maxWidth: "200px",
              height: "auto",
              marginBottom: "20px",
            }}
          />
          <Typography variant="h4" gutterBottom>
            ¡Gracias por enviar sus respuestas!
          </Typography>
          <Typography variant="h6" paragraph>
            Lo invitamos a visitar nuestro sitio web haciendo clic en el
            siguiente botón:
          </Typography>

          {/* Imagen después del mensaje */}

          <br></br>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={redirigir}
          >
            Visitar
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default GraciasComponente;
